export enum MetaFieldTypes {
    date = 'date',
    time = 'time',
    textarea = 'textarea',
    input = 'input',
    gallery = 'gallery',
    number = 'number',
    select = 'select',
    list = 'list',
    titleImage = 'titleImage',
    checkboxMulti = 'checkboxMulti',
    }

export type MetaFieldDescription = {
    name: string,
    label: string,
    type: MetaFieldTypes,
    unit?: string,
    options?: string[] | any,
}

export type MetaField = {
    name: string,
    value: string,
    customValue?: string,
}

export type MetaFieldGroup = {
    name: string,
    fields: MetaFieldDescription[],
}